<script>

export default {
    name: 'quiz',
    props: {
        answer: {required: true},
        options:{required: true},
        question:{required: true}
    },
    data() {
        return {
            answerData : JSON.parse(this.answer),
            optionsData : JSON.parse(this.options),
            questionData : JSON.parse(this.question),
            selectedAnswer: null
        }
    }
}
</script>
<template lang="pug">
    .quiz-component
        span(v-html="questionData")

        .quiz-options
            .option(
                v-for="(option, key) in optionsData"
                :key='`${_uid}-${key}`'
            )
                input(
                    type="radio"
                    :id='`${_uid}-${key}-option`'
                    :value="option.content"
                    v-model="selectedAnswer"
                )
                label(:for='`${_uid}-${key}-option`') {{ option.content }}
        .quiz-answer
            template(v-if="selectedAnswer && selectedAnswer == answerData")
                .correct Yes! You've got it correct!
            template(v-if="selectedAnswer && selectedAnswer != answerData")
                .wrong Nope! Try again
</template>